module.exports = __webpack_public_path__ + "img/poodle.c5d742f.png";